import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { AlertsStore } from '../../../alerts/alerts.store';
import { AlertSeverityComponent } from '../../../alerts/components/alert-severity/alert-severity.component';
import { ALERT_SEVERITY } from '../../../alerts/models/Alert';

@Component({
    selector: 'app-alert-indicator',
    imports: [AlertSeverityComponent, TranslatePipe],
    templateUrl: './alert-indicator.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './alert-indicator.component.scss',
})
export class AlertIndicatorComponent {
    private readonly alertsStore = inject(AlertsStore);

    ALERT_SEVERITY = ALERT_SEVERITY;

    protected readonly newAlertCounts = computed(() => {
        const { high, normal } = this.alertsStore.newAlertsBySeverity();
        return { high, normal, total: high + normal };
    });
}
